export const title = (p5, trait, width, pixels) => {
  const xcenter = width / 2;
  const margin = p5.height / 2.2;
  const textSize = width / 40;
  const sizes = {
    16: "20'",
    20: "25'",
    24: "30'",
    27: "35'",
    32: "41'",
  };

  p5.push();
  p5.translate(width);
  p5.textAlign(p5.CENTER);
  p5.textSize(textSize * 2.75);
  let title = `${trait.kitName} - ${sizes[trait.size]}`;
  p5.text(title, xcenter, margin);
  p5.pop();

  p5.push();
  p5.translate(width);
  p5.textSize(textSize);
  p5.text(
    `${trait.h / 12 / pixels}' WALLS`,
    xcenter - p5.textWidth(title),
    margin * 0.85
  );
  p5.pop();

  p5.push();
  p5.translate(width);
  p5.textSize(textSize);
  p5.text(
    `${trait.bottomPlate} BOTTOM PLATES`,
    xcenter - p5.textWidth(title),
    margin * 0.8
  );
  p5.pop();

  p5.push();
  p5.translate(width);
  p5.textSize(textSize);
  p5.text(`${trait.eaves}" EAVES`, xcenter - p5.textWidth(title), margin * 1.1);
  p5.pop();

  p5.push();
  p5.translate(width);
  p5.textSize(textSize);
  p5.text(
    `${trait.stud / pixels}" STUD SPACING`,
    xcenter - p5.textWidth(title),
    margin * 1.15
  );
  p5.pop();

  if (trait.nailingPattern) {
    p5.push();
    p5.translate(width);
    p5.textSize(textSize);
    let nailingPattern = trait.nailingPattern.split(/[^A-Za-z0-9]/);
    p5.text(
      `${nailingPattern[0]}" / ${nailingPattern[1]}" NAILING PATTERN`,
      xcenter - p5.textWidth(title),
      margin * 1.2
    );
    p5.pop();
  }
};
